import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Form, Input, Result, Typography } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useForgotPassword } from '@presentation/hooks/useAuth';
import { paths } from '@app/routes/paths';

interface ForgotPasswordFormValues {
  email: string;
}

export const ForgotPasswordPage = () => {
  const forgotPassword = useForgotPassword();
  const [submittedEmail, setSubmittedEmail] = useState('');

  const handleFinish = (values: ForgotPasswordFormValues) => {
    setSubmittedEmail(values.email);
    forgotPassword.mutate(values.email);
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-sm">
        {forgotPassword.isSuccess ? (
          <Result
            status="success"
            title="Check your email"
            subTitle={`If an account exists for ${submittedEmail}, we sent a link to reset your password.`}
            extra={<Link to={paths.login}>Back to sign in</Link>}
          />
        ) : (
          <>
            <Typography.Title level={4} className="!mb-1">
              Forgot password
            </Typography.Title>
            <Typography.Text type="secondary">
              Enter your email and we&apos;ll send you a reset link.
            </Typography.Text>

            <Form layout="vertical" className="mt-6" onFinish={handleFinish}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Email is required' }, { type: 'email' }]}
              >
                <Input prefix={<MailOutlined />} autoComplete="email" size="large" />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={forgotPassword.isPending}
              >
                Send reset link
              </Button>

              <div className="mt-4 text-center">
                <Typography.Text type="secondary">Remembered it? </Typography.Text>
                <Link to={paths.login}>Sign in</Link>
              </div>
            </Form>
          </>
        )}
      </Card>
    </div>
  );
};
